/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B10060 得意先マスタメンテ
 */
import {
  SText,
  SCodeSelect,
  SDateField,
  SFrame,
  SLabel,
  SNumberField,
  STextField,
  msgState,
  SNormalButton,
  SFileButton,
  SConfirmDialog,
} from "components";
import { labels } from "messages/labels";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { focusState, navigateTypeState, useFocus } from "states";
import { useNavigate } from "react-router-dom";
import {
  B100060Mode,
  B100060Tankahasuichi,
  B100ShokaKbn,
  getSCode,
  JodaihyojiKbn,
  KaishuKbn,
  KaishuyoteiM,
  KinmaremeKbn,
  KyakusakinoKbn,
  NonyuKbn,
  SakujoyoteiKbn,
  SCode,
  SeikyuKbn,
  SeikyushoKbn,
  SeikyushokeishikiKbn,
  SeikyushosaibanKbn,
  ShokuchiKbn,
  ShutsuryokushohinCd,
  TankamarumeKbn,
  TokuiKbn,
  UrikakeKbn,
  ZeiKbn,
  ZeimarumeKbn,
} from "../../messages/codes";
import { B000150 } from "pages/b000/B000150";
import { getClientMessage } from "messages";
import {
  catchRestError,
  B000190ItakusokoNmr,
  B000111UnsogaishaNm,
  B000111DenpyoshubetsuNm,
  B000111TenpudenpyoNm,
  B000140ShainNmBumonCd,
  B000130BumonNm,
  B000140UrikakeshainNmBumonCd,
  B000130UrikakebumonNm,
  B000111TokuibunNm1,
  B000111TokuibunNm2,
  B000111TokuibunNm3,
  B000111TokuibunNm4,
  B000111TokuibunNm5,
} from "clients/rest";
import {
  B100060Create,
  B100060Update,
  B100060Tokui,
  B100060SanshoTokui,
  B100060HandleSetNmAndHasuichi,
} from "clients/rest/b100/B100060";
import { B000190 } from "pages/b000/B000190";
import { date } from "services";
import { B000140 } from "pages/b000/B000140";
import { Box } from "@mui/material";
import { calledParam, meishoKbn, seikyuKbn, urikakeKbn } from "services/codes";
import { B000111 } from "pages/b000/B000111";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  modeKbn: SCode;
  tokuiCd: string;
  tokuishitenCd: string;
  sanshoTokuiCd: string;
  sanshoTokuishitenCd: string;
  tokuiNm1: string;
  tokuiNm2: string;
  tokuiKana: string;
  tokuiNmr: string;
  shokuchiKbn: SCode;
  postCd: string;
  address1: string;
  address2: string;
  telNo: string;
  faxNo: string;
  shokaKbn: SCode;
  itakusokoCd: string;
  sokoNmr: string;
  tokuiKbn: SCode;
  seikyuKbn: SCode;
  seikyuCd: string;
  seikyushitenCd: string;
  urikakeKbn: SCode;
  urikakeCd: string;
  urikakeshitenCd: string;
  nonyuKbn: SCode;
  unsogaishaCd: string;
  unsogaishaNm: string;
  shainCd: string;
  shainNm: string;
  bumonCd: string;
  bumonNm: string;
  urikakeshainCd: string;
  urikakeshainNm: string;
  urikakebumonCd: string;
  urikakebumonNm: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  shimeD: string;
  kaishuyoteiM: SCode;
  kaishuyoteiD: string;
  kaishuKbn: SCode;
  seikyushoKbn: SCode;
  seikyushokeishikiKbn: SCode;
  seikyushosaibanKbn: SCode;
  seikyushoNo: string;
  denpyogyosu: string;
  denpyoshubetsuCd: string;
  denpyoshubetsuNm: string;
  denpyoKbn: string;
  tenpudenpyoCd: string;
  tenpudenpyoNm: string;
  ritsu: string;
  bunrui: string;
  shutsuryokushohinCd: SCode;
  torihikisakiCd: string;
  hyakatenCd: string;
  shatenCd: string;
  kinmarumeKbn: SCode;
  zeimarumeKbn: SCode;
  zeiKbn: SCode;
  tankamarumeKbn: SCode;
  tankahasuichiKbn: SCode;
  tankahasuichi: string;
  tankaKakeritsu: string;
  jodaihyojiKbn: SCode;
  sakujoyoteiKbn: SCode;
  kyakusakinoKbn: SCode;
  kigyoCd: string;
  tenpoCd: string;
  tokuibunCd1: string;
  tokuibunNm1: string;
  tokuibunCd2: string;
  tokuibunNm2: string;
  tokuibunCd3: string;
  tokuibunNm3: string;
  tokuibunCd4: string;
  tokuibunNm4: string;
  tokuibunCd5: string;
  tokuibunNm5: string;
  version: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  modeKbn: getSCode(B100060Mode, "0"),
  tokuiCd: "",
  tokuishitenCd: "",
  sanshoTokuiCd: "",
  sanshoTokuishitenCd: "",
  tokuiNm1: "",
  tokuiNm2: "",
  tokuiKana: "",
  tokuiNmr: "",
  shokuchiKbn: getSCode(ShokuchiKbn, "0"),
  postCd: "",
  address1: "",
  address2: "",
  telNo: "",
  faxNo: "",
  shokaKbn: getSCode(B100ShokaKbn, "0"),
  itakusokoCd: "",
  sokoNmr: "",
  tokuiKbn: getSCode(TokuiKbn, "1"),
  seikyuKbn: getSCode(SeikyuKbn, "1"),
  seikyuCd: "",
  seikyushitenCd: "",
  urikakeKbn: getSCode(UrikakeKbn, "1"),
  urikakeCd: "",
  urikakeshitenCd: "",
  nonyuKbn: getSCode(NonyuKbn, "1"),
  unsogaishaCd: "",
  unsogaishaNm: "",
  shainCd: "",
  shainNm: "",
  bumonCd: "",
  bumonNm: "",
  urikakeshainCd: "",
  urikakeshainNm: "",
  urikakebumonCd: "",
  urikakebumonNm: "",
  torihikikaishiYmd: date(),
  torihikishuryoYmd: "99991231",
  shimeD: "",
  kaishuyoteiM: getSCode(KaishuyoteiM, "0"),
  kaishuyoteiD: "",
  kaishuKbn: getSCode(KaishuKbn, "31"),
  seikyushoKbn: getSCode(SeikyushoKbn, "1"),
  seikyushokeishikiKbn: getSCode(SeikyushokeishikiKbn, "1"),
  seikyushosaibanKbn: getSCode(SeikyushosaibanKbn, "1"),
  seikyushoNo: "",
  denpyogyosu: "",
  denpyoshubetsuCd: "",
  denpyoshubetsuNm: "",
  denpyoKbn: "",
  tenpudenpyoCd: "",
  tenpudenpyoNm: "",
  ritsu: "",
  bunrui: "",
  shutsuryokushohinCd: getSCode(ShutsuryokushohinCd, "0"),
  torihikisakiCd: "",
  hyakatenCd: "",
  shatenCd: "",
  kinmarumeKbn: getSCode(KinmaremeKbn, "0"),
  zeimarumeKbn: getSCode(ZeimarumeKbn, "0"),
  zeiKbn: getSCode(ZeiKbn, "0"),
  tankamarumeKbn: getSCode(TankamarumeKbn, "1"),
  tankahasuichiKbn: getSCode(B100060Tankahasuichi, "0"),
  tankahasuichi: "2",
  tankaKakeritsu: "100",
  jodaihyojiKbn: getSCode(JodaihyojiKbn, "0"),
  sakujoyoteiKbn: getSCode(SakujoyoteiKbn, "0"),
  kyakusakinoKbn: getSCode(KyakusakinoKbn, "0"),
  kigyoCd: "",
  tenpoCd: "",
  tokuibunCd1: "",
  tokuibunNm1: "",
  tokuibunCd2: "",
  tokuibunNm2: "",
  tokuibunCd3: "",
  tokuibunNm3: "",
  tokuibunCd4: "",
  tokuibunNm4: "",
  tokuibunCd5: "",
  tokuibunNm5: "",
  version: "",
};
// 固定値
// モード(新規)
const modeNew = "0";

const seikyuKbnNaru = "1";
const urikakeKbnNaru = "1";

const focusId = "B100060";

// B100060 得意先マスタメンテ
export const B100060 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 遷移元データ取得用
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移の処理
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);

  // 活性設定
  // 新規モードかどうか
  const isNew = methods.watch("modeKbn")?.value === modeNew;
  // 請求先区分が「1:なる」かどうか
  const isSeikyuNaru = methods.watch("seikyuKbn")?.value === seikyuKbnNaru;
  // 売掛先区分が「1:なる」かどうか
  const isUrikakeNaru = methods.watch("urikakeKbn")?.value === urikakeKbnNaru;

  // 初期表示イベント
  useEffect(() => {
    // unregisterを使用する値をresetで初期化(defalutValueが無視され、初期値にundifindが設定されることがあるため)
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      tokuiCd: "",
      tokuishitenCd: "",
      sanshoTokuiCd: "",
      sanshoTokuishitenCd: "",
    });

    focus(1);
  }, []);

  // モード変更時
  const handleChangeModeKbn = () => {
    if (isNew) {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        tokuiCd: "",
        tokuishitenCd: "",
        sanshoTokuiCd: "",
        sanshoTokuishitenCd: "",
      });
      methods.setValue("modeKbn", getSCode(B100060Mode, "1"));
    } else {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        tokuiCd: "",
        tokuishitenCd: "",
        sanshoTokuiCd: "",
        sanshoTokuishitenCd: "",
      });
    }
  };

  // 更新
  const handleClickUpdateButton = () => {
    // 新規の場合
    if (isNew) {
      B100060Create(methods)
        .then(() => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            tokuiCd: "",
            tokuishitenCd: "",
            sanshoTokuiCd: "",
            sanshoTokuishitenCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("tokuiCd", "");
          setMsg(getClientMessage("B100060_001"));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
    // 更新の場合
    else {
      B100060Update(methods)
        .then(() => {
          methods.reset();
          methods.reset({
            ...methods.getValues(),
            tokuiCd: "",
            tokuishitenCd: "",
            sanshoTokuiCd: "",
            sanshoTokuishitenCd: "",
          });
          // ↓これがあると完了メッセージが表示される
          methods.setValue("tokuiCd", "");
          setMsg(getClientMessage("B100060_002"));
        })
        .catch((reason) => {
          catchRestError(reason, navigate, setMsg);
        });
    }
  };

  // 得意先、得意先支店変更時
  const hendleChangeTokui = () => {
    // 変更されていない場合は切替しない
    if (
      !methods.getFieldState("tokuiCd").isDirty &&
      !methods.getFieldState("tokuishitenCd").isDirty
    ) {
      return;
    }

    // フォームのデータを取得する。
    const fields = methods.getValues();

    // 請求先区分が 1(なる) の場合
    if (Number(fields.seikyuKbn?.value) === seikyuKbn.naru) {
      methods.setValue("seikyuCd", fields.tokuiCd);
      methods.setValue("seikyushitenCd", fields.tokuishitenCd);
    }

    // 売掛先区分が 1(なる) の場合
    if (Number(fields.urikakeKbn?.value) === urikakeKbn.naru) {
      methods.setValue("urikakeCd", fields.tokuiCd);
      methods.setValue("urikakeshitenCd", fields.tokuishitenCd);
    }

    // 値を保持
    methods.unregister("tokuiCd", { keepValue: true });
    methods.unregister("tokuishitenCd", { keepValue: true });

    // モードが 0(新規) の場合
    if (fields.modeKbn?.value === modeNew) return;

    // 得意先情報表示処理
    B100060Tokui(methods, navigate, setMsg);
  };

  // 請求先区分変更時
  const hendleChangeSeikyuKbn = () => {
    const fields = methods.getValues();

    // 請求先区分が 0(ならない) の場合
    if (fields.seikyuKbn?.value === seikyuKbnNaru) {
      if (!fields.tokuiCd || !fields.tokuishitenCd) {
        return;
      }
      methods.setValue("seikyuCd", fields.tokuiCd);
      methods.setValue("seikyushitenCd", fields.tokuishitenCd);
    }
    // 請求先区分が 0(ならない) の場合
    else {
      methods.setValue("seikyuCd", "");
      methods.setValue("seikyushitenCd", "");
      methods.setValue("urikakeKbn", getSCode(UrikakeKbn, "0"));
      methods.setValue("urikakeCd", "");
      methods.setValue("urikakeshitenCd", "");
    }
  };

  // 売掛先区分変更時
  const handleChangeUrikakeKbn = () => {
    const fields = methods.getValues();

    // 請求先区分が 0(ならない) の場合
    if (fields.urikakeKbn?.value === urikakeKbnNaru) {
      if (!fields.tokuiCd || !fields.tokuishitenCd) {
        return;
      }
      methods.setValue("urikakeCd", fields.tokuiCd);
      methods.setValue("urikakeshitenCd", fields.tokuishitenCd);
    }
    // 売掛先区分が 0(ならない) の場合
    else {
      methods.setValue("urikakeCd", "");
      methods.setValue("urikakeshitenCd", "");
    }
  };

  // 担当者の変更
  const HandleChangeShainCd = async () => {
    // 同期させる
    (async () => {
      // 担当者名を取得
      await B000140ShainNmBumonCd(methods, navigate, setMsg);
      // 担当部門名を取得
      await B000130BumonNm(methods, navigate, setMsg);
    })();
  };

  // 売掛担当者の変更
  const HandleChangeUrikakeshainCd = async () => {
    // 同期させる
    (async () => {
      // 売掛担当者名を取得
      await B000140UrikakeshainNmBumonCd(methods, navigate, setMsg);
      // 売掛担当部門名を取得
      await B000130UrikakebumonNm(methods, navigate, setMsg);
    })();
  };

  // excelボタンクリック時
  const handleMoveOutput = () => {
    // 得意先マスタ出力画面へ遷移する。
    setMenuNavigate("next");
    navigate("/b100063");
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="得意先マスタメンテ"
          gridTemplateColumns="8rem 7rem 5rem 8rem 7rem 5rem 1rem 8rem 4rem 3rem 5rem 10rem"
        >
          <SText gridColumn="span 11"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(67)}
            onClick={handleMoveOutput}
          />

          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            name="modeKbn"
            label="モード"
            required
            options={B100060Mode}
            {...register(1)}
            onChange={() => handleChangeModeKbn()}
          />
          <SLabel required gridColumn="1">
            得意先コード
          </SLabel>
          {isNew ? (
            <>
              <SNumberField
                name="tokuiCd"
                label="得意先コード"
                code
                required
                size={6}
                onBlur={() => hendleChangeTokui()}
                {...register(2)}
              />
              <SNumberField
                name="tokuishitenCd"
                label="得意先支店コード"
                code
                required
                size={4}
                onBlur={() => hendleChangeTokui()}
                {...register(3)}
              />
            </>
          ) : (
            <>
              <SNumberField
                name="tokuiCd"
                label="得意先コード"
                code
                required
                size={6}
                onBlur={() => hendleChangeTokui()}
                {...register(2)}
              />
              <SNumberField
                name="tokuishitenCd"
                label="得意先支店コード"
                code
                required
                size={4}
                dialog={
                  <B000150 deljogaiKbn="1" calledParam={calledParam.zenken} />
                }
                handleSubmit={(data: any) => {
                  methods.setValue("tokuiCd", data.tokuiCd ?? "");
                  methods.setValue("tokuishitenCd", data.tokuishitenCd ?? "");
                  methods.setValue("tokuiNm1", data.tokuiNm1 ?? "");
                  methods.setValue("tokuiNm2", data.tokuiNm2 ?? "");
                  methods.setValue("tokuiKana", data.tokuiKana ?? "");
                  methods.setValue("tokuiNmr", data.tokuiNmr ?? "");
                  methods.setValue(
                    "shokuchiKbn",
                    getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
                  );
                  methods.setValue("postCd", data.postCd ?? "");
                  methods.setValue("address1", data.address1 ?? "");
                  methods.setValue("address2", data.address2 ?? "");
                  methods.setValue("telNo", data.telNo ?? "");
                  methods.setValue("faxNo", data.faxNo ?? "");
                  methods.setValue(
                    "shokaKbn",
                    getSCode(B100ShokaKbn, data.shokaKbn) ?? null
                  );
                  methods.setValue("itakusokoCd", data.itakusokoCd ?? "");
                  methods.setValue(
                    "tokuiKbn",
                    getSCode(TokuiKbn, data.tokuiKbn) ?? null
                  );
                  methods.setValue(
                    "seikyuKbn",
                    getSCode(SeikyuKbn, data.seikyuKbn) ?? null
                  );
                  methods.setValue("seikyuCd", data.seikyuCd ?? "");
                  methods.setValue("seikyushitenCd", data.seikyushitenCd ?? "");
                  methods.setValue(
                    "urikakeKbn",
                    getSCode(UrikakeKbn, data.urikakeKbn) ?? null
                  );
                  methods.setValue("urikakeCd", data.urikakeCd ?? "");
                  methods.setValue(
                    "urikakeshitenCd",
                    data.urikakeshitenCd ?? ""
                  );
                  methods.setValue(
                    "nonyuKbn",
                    getSCode(NonyuKbn, data.nonyuKbn) ?? null
                  );
                  methods.setValue("unsogaishaCd", data.unsogaishaCd ?? "");
                  methods.setValue("shainCd", data.shainCd ?? "");
                  methods.setValue("urikakeshainCd", data.urikakeshainCd ?? "");
                  methods.setValue(
                    "torihikikaishiYmd",
                    data.torihikikaishiYmd ?? ""
                  );
                  methods.setValue(
                    "torihikishuryoYmd",
                    data.torihikishuryoYmd ?? ""
                  );
                  methods.setValue("shimeD", data.shimeD ?? "");
                  methods.setValue(
                    "kaishuyoteiM",
                    getSCode(KaishuyoteiM, data.kaishuyoteiM) ?? null
                  );
                  methods.setValue("kaishuyoteiD", data.kaishuyoteiD ?? "");
                  methods.setValue(
                    "kaishuKbn",
                    getSCode(KaishuKbn, data.kaishuKbn) ?? null
                  );
                  methods.setValue(
                    "seikyushoKbn",
                    getSCode(SeikyushoKbn, data.seikyushoKbn) ?? null
                  );
                  methods.setValue(
                    "seikyushokeishikiKbn",
                    getSCode(SeikyushokeishikiKbn, data.seikyushokeishikiKbn) ??
                      null
                  );
                  methods.setValue(
                    "seikyushosaibanKbn",
                    getSCode(SeikyushosaibanKbn, data.seikyushosaibanKbn) ??
                      null
                  );
                  methods.setValue("seikyushoNo", data.seikyushoNo ?? "");
                  methods.setValue("denpyogyosu", data.denpyogyosu ?? "");
                  methods.setValue(
                    "denpyoshubetsuCd",
                    data.denpyoshubetsuCd ?? ""
                  );
                  methods.setValue("denpyogyosu", data.denpyogyosu ?? "");
                  methods.setValue("denpyoKbn", data.denpyoKbn ?? "");
                  methods.setValue("tenpudenpyoCd", data.tenpudenpyoCd ?? "");
                  methods.setValue("ritsu", data.ritsu ?? "");
                  methods.setValue("bunrui", data.bunrui ?? "");
                  methods.setValue(
                    "shutsuryokushohinCd",
                    getSCode(ShutsuryokushohinCd, data.shutsuryokushohinCd) ??
                      null
                  );
                  methods.setValue("torihikisakiCd", data.torihikisakiCd ?? "");
                  methods.setValue("hyakatenCd", data.hyakatenCd ?? "");
                  methods.setValue("shatenCd", data.shatenCd ?? "");
                  methods.setValue(
                    "kinmarumeKbn",
                    getSCode(KinmaremeKbn, data.kinmarumeKbn) ?? null
                  );
                  methods.setValue(
                    "zeimarumeKbn",
                    getSCode(ZeimarumeKbn, data.zeimarumeKbn) ?? null
                  );
                  methods.setValue(
                    "zeiKbn",
                    getSCode(ZeiKbn, data.zeiKbn) ?? null
                  );
                  methods.setValue(
                    "tankamarumeKbn",
                    getSCode(TankamarumeKbn, data.tankamarumeKbn) ?? null
                  );
                  methods.setValue("tankaKakeritsu", data.tankaKakeritsu ?? "");
                  methods.setValue(
                    "jodaihyojiKbn",
                    getSCode(JodaihyojiKbn, data.jodaihyojiKbn) ?? null
                  );
                  methods.setValue(
                    "sakujoyoteiKbn",
                    getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
                  );
                  methods.setValue(
                    "kyakusakinoKbn",
                    getSCode(KyakusakinoKbn, data.kyakusakinoKbn) ?? null
                  );
                  methods.setValue("kigyoCd", data.kigyoCd ?? "");
                  methods.setValue("tenpoCd", data.tenpoCd ?? "");
                  methods.setValue("tokuibunCd1", data.tokuibunCd1 ?? "");
                  methods.setValue("tokuibunCd2", data.tokuibunCd2 ?? "");
                  methods.setValue("tokuibunCd3", data.tokuibunCd3 ?? "");
                  methods.setValue("tokuibunCd4", data.tokuibunCd4 ?? "");
                  methods.setValue("tokuibunCd5", data.tokuibunCd5 ?? "");
                  methods.setValue("version", data.version ?? "");

                  // コードに紐づく名称、端数位置の設定
                  B100060HandleSetNmAndHasuichi(methods, navigate, setMsg);
                }}
                onBlur={() => hendleChangeTokui()}
                {...register(3)}
              />
            </>
          )}
          <SLabel gridColumn={8}>参照コード</SLabel>
          <SNumberField
            name="sanshoTokuiCd"
            code
            disabled={!isNew}
            size={6}
            gridColumn="span 2"
            onBlur={() => B100060SanshoTokui(methods, navigate, setMsg)}
            {...register(4)}
          />
          <SNumberField
            name="sanshoTokuishitenCd"
            code
            disabled={!isNew}
            size={4}
            dialog={
              <B000150 deljogaiKbn="1" calledParam={calledParam.zenken} />
            }
            handleSubmit={(data: any) => {
              methods.setValue("sanshoTokuiCd", data.tokuiCd ?? "");
              methods.setValue("sanshoTokuishitenCd", data.tokuishitenCd ?? "");
              methods.setValue("tokuiNm1", data.tokuiNm1 ?? "");
              methods.setValue("tokuiNm2", data.tokuiNm2 ?? "");
              methods.setValue("tokuiKana", data.tokuiKana ?? "");
              methods.setValue("tokuiNmr", data.tokuiNmr ?? "");
              methods.setValue(
                "shokuchiKbn",
                getSCode(ShokuchiKbn, data.shokuchiKbn) ?? null
              );
              methods.setValue("postCd", data.postCd ?? "");
              methods.setValue("address1", data.address1 ?? "");
              methods.setValue("address2", data.address2 ?? "");
              methods.setValue("telNo", data.telNo ?? "");
              methods.setValue("faxNo", data.faxNo ?? "");
              methods.setValue(
                "shokaKbn",
                getSCode(B100ShokaKbn, data.shokaKbn) ?? null
              );
              methods.setValue("itakusokoCd", data.itakusokoCd ?? "");
              methods.setValue(
                "tokuiKbn",
                getSCode(TokuiKbn, data.tokuiKbn) ?? null
              );
              methods.setValue(
                "seikyuKbn",
                getSCode(SeikyuKbn, data.seikyuKbn) ?? null
              );
              methods.setValue("seikyuCd", methods.getValues().seikyuCd ?? "");
              methods.setValue(
                "seikyushitenCd",
                methods.getValues().seikyushitenCd ?? ""
              );
              methods.setValue(
                "urikakeKbn",
                getSCode(UrikakeKbn, data.urikakeKbn) ?? null
              );
              methods.setValue(
                "urikakeCd",
                methods.getValues().urikakeCd ?? ""
              );
              methods.setValue(
                "urikakeshitenCd",
                methods.getValues().urikakeshitenCd ?? ""
              );
              methods.setValue(
                "nonyuKbn",
                getSCode(NonyuKbn, data.nonyuKbn) ?? null
              );
              methods.setValue("unsogaishaCd", data.unsogaishaCd ?? "");
              methods.setValue("shainCd", data.shainCd ?? "");
              methods.setValue("urikakeshainCd", data.urikakeshainCd ?? "");
              methods.setValue(
                "torihikikaishiYmd",
                data.torihikikaishiYmd ?? ""
              );
              methods.setValue(
                "torihikishuryoYmd",
                data.torihikishuryoYmd ?? ""
              );
              methods.setValue("shimeD", data.shimeD ?? "");
              methods.setValue(
                "kaishuyoteiM",
                getSCode(KaishuyoteiM, data.kaishuyoteiM) ?? null
              );
              methods.setValue("kaishuyoteiD", data.kaishuyoteiD ?? "");
              methods.setValue(
                "kaishuKbn",
                getSCode(KaishuKbn, data.kaishuKbn) ?? null
              );
              methods.setValue(
                "seikyushoKbn",
                getSCode(SeikyushoKbn, data.seikyushoKbn) ?? null
              );
              methods.setValue(
                "seikyushokeishikiKbn",
                getSCode(SeikyushokeishikiKbn, data.seikyushokeishikiKbn) ??
                  null
              );
              methods.setValue(
                "seikyushosaibanKbn",
                getSCode(SeikyushosaibanKbn, data.seikyushosaibanKbn) ?? null
              );
              methods.setValue("seikyushoNo", data.seikyushoNo ?? "");
              methods.setValue("denpyogyosu", data.denpyogyosu ?? "");
              methods.setValue("denpyoshubetsuCd", data.denpyoshubetsuCd ?? "");
              methods.setValue("denpyogyosu", data.denpyogyosu ?? "");
              methods.setValue("denpyoKbn", data.denpyoKbn ?? "");
              methods.setValue("tenpudenpyoCd", data.tenpudenpyoCd ?? "");
              methods.setValue("ritsu", data.ritsu ?? "");
              methods.setValue("bunrui", data.bunrui ?? "");
              methods.setValue(
                "shutsuryokushohinCd",
                getSCode(ShutsuryokushohinCd, data.shutsuryokushohinCd) ?? null
              );
              methods.setValue("torihikisakiCd", data.torihikisakiCd ?? "");
              methods.setValue("hyakatenCd", data.hyakatenCd ?? "");
              methods.setValue("shatenCd", data.shatenCd ?? "");
              methods.setValue(
                "kinmarumeKbn",
                getSCode(KinmaremeKbn, data.kinmarumeKbn) ?? null
              );
              methods.setValue(
                "zeimarumeKbn",
                getSCode(ZeimarumeKbn, data.zeimarumeKbn) ?? null
              );
              methods.setValue("zeiKbn", getSCode(ZeiKbn, data.zeiKbn) ?? null);
              methods.setValue(
                "tankamarumeKbn",
                getSCode(TankamarumeKbn, data.tankamarumeKbn) ?? null
              );
              methods.setValue("tankaKakeritsu", data.tankaKakeritsu ?? "");
              methods.setValue(
                "jodaihyojiKbn",
                getSCode(JodaihyojiKbn, data.jodaihyojiKbn) ?? null
              );
              methods.setValue(
                "sakujoyoteiKbn",
                getSCode(SakujoyoteiKbn, data.sakujoyoteiKbn) ?? null
              );
              methods.setValue(
                "kyakusakinoKbn",
                getSCode(KyakusakinoKbn, data.kyakusakinoKbn) ?? null
              );
              methods.setValue("kigyoCd", data.kigyoCd ?? "");
              methods.setValue("tenpoCd", data.tenpoCd ?? "");
              methods.setValue("tokuibunCd1", data.tokuibunCd1 ?? "");
              methods.setValue("tokuibunCd2", data.tokuibunCd2 ?? "");
              methods.setValue("tokuibunCd3", data.tokuibunCd3 ?? "");
              methods.setValue("tokuibunCd4", data.tokuibunCd4 ?? "");
              methods.setValue("tokuibunCd5", data.tokuibunCd5 ?? "");

              // コードに紐づく名称、端数位置の設定
              B100060HandleSetNmAndHasuichi(methods, navigate, setMsg);
            }}
            onBlur={() => B100060SanshoTokui(methods, navigate, setMsg)}
            {...register(5)}
          />

          <SLabel required gridColumn="1">
            得意先名1
          </SLabel>
          <STextField
            name="tokuiNm1"
            label="得意先名1"
            required
            gridColumn="span 5"
            size={40}
            {...register(6)}
          />
          <SLabel gridColumn={8}>〒</SLabel>
          <STextField
            name="postCd"
            gridColumn="span 2"
            size={10}
            {...register(11)}
          />

          <SLabel gridColumn="1">得意先名2</SLabel>
          <STextField
            name="tokuiNm2"
            gridColumn="span 5"
            size={40}
            {...register(7)}
          />
          <SLabel gridColumn={8}>住所1</SLabel>
          <STextField
            name="address1"
            gridColumn="span 4"
            size={40}
            {...register(12)}
          />

          <SLabel gridColumn="1">カナ名</SLabel>
          <STextField
            name="tokuiKana"
            gridColumn="span 5"
            size={40}
            {...register(8)}
          />
          <SLabel gridColumn={8}>住所2</SLabel>
          <STextField
            name="address2"
            gridColumn="span 4"
            size={40}
            {...register(13)}
          />

          <SLabel required gridColumn="1">
            略名
          </SLabel>
          <STextField
            name="tokuiNmr"
            label="略名"
            required
            size={24}
            gridColumn="span 4"
            {...register(9)}
          />
          <SLabel gridColumn={8}>TEL</SLabel>
          <STextField
            name="telNo"
            size={15}
            gridColumn="span 2"
            {...register(14)}
          />

          <SLabel required gridColumn="1">
            諸口
          </SLabel>
          <SCodeSelect
            name="shokuchiKbn"
            label="諸口"
            required
            options={ShokuchiKbn}
            {...register(10)}
          />
          <SLabel gridColumn={8}>FAX</SLabel>
          <STextField
            name="faxNo"
            size={15}
            gridColumn="span 2"
            {...register(15)}
          />

          <SLabel required gridColumn="1">
            消化
          </SLabel>
          <SCodeSelect
            name="shokaKbn"
            label="消化"
            required
            options={B100ShokaKbn}
            {...register(16)}
          />
          <SLabel gridColumn={8}>委託倉庫</SLabel>
          <SNumberField
            name="itakusokoCd"
            code
            size={3}
            dialog={<B000190 />}
            handleSubmit={(data: any) => {
              methods.setValue("itakusokoCd", data?.sokoCd);
              methods.setValue("sokoNmr", data?.sokoNmr);
            }}
            onBlur={() => B000190ItakusokoNmr(methods, navigate, setMsg)}
            {...register(17)}
          />
          <STextField name="sokoNmr" gridColumn="span 3" disabled />

          <SLabel required gridColumn="1">
            得意先区分
          </SLabel>
          <SCodeSelect
            name="tokuiKbn"
            label="得意先区分"
            required
            options={TokuiKbn}
            {...register(18)}
          />

          <SLabel required gridColumn="1">
            請求先区分
          </SLabel>
          <SCodeSelect
            name="seikyuKbn"
            label="請求先区分"
            required
            options={SeikyuKbn}
            {...register(19)}
            onChange={() => hendleChangeSeikyuKbn()}
          />
          <SText align="center">⇨</SText>
          <SLabel required>請求先</SLabel>
          <SNumberField
            name="seikyuCd"
            label="請求先コード"
            disabled={isSeikyuNaru}
            code
            required
            size={6}
            {...register(20)}
          />
          <SNumberField
            name="seikyushitenCd"
            label="請求先支店コード"
            disabled={isSeikyuNaru}
            code
            required
            size={4}
            dialog={<B000150 calledParam={calledParam.seikyu} />}
            handleSubmit={(data: any) => {
              methods.setValue("seikyuCd", data?.seikyuCd);
              methods.setValue("seikyushitenCd", data?.seikyushitenCd);
            }}
            {...register(21)}
          />

          <SLabel required gridColumn={1}>
            売掛先区分
          </SLabel>
          <SCodeSelect
            name="urikakeKbn"
            label="売掛先区分"
            required
            disabled={!isSeikyuNaru}
            options={UrikakeKbn}
            {...register(22)}
            onChange={() => handleChangeUrikakeKbn()}
          />
          <SText align="center">⇨</SText>
          <SLabel required>売掛先</SLabel>
          <SNumberField
            name="urikakeCd"
            label="売掛先コード"
            disabled={isUrikakeNaru}
            code
            required
            size={6}
            {...register(23)}
          />
          <SNumberField
            name="urikakeshitenCd"
            label="売掛先支店コード"
            disabled={isUrikakeNaru}
            code
            required
            size={4}
            dialog={<B000150 calledParam={calledParam.urikake} />}
            handleSubmit={(data: any) => {
              methods.setValue("urikakeCd", data?.urikakeCd);
              methods.setValue("urikakeshitenCd", data?.urikakeshitenCd);
            }}
            {...register(24)}
          />

          <SLabel required gridColumn={1}>
            納入先区分
          </SLabel>
          <SCodeSelect
            name="nonyuKbn"
            label="納入先区分"
            required
            options={NonyuKbn}
            {...register(25)}
          />
          <SLabel gridColumn={8}>運送会社</SLabel>
          <SNumberField
            name="unsogaishaCd"
            code
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.unsogaisha} />}
            handleSubmit={(data: any) => {
              methods.setValue("unsogaishaCd", data?.meishoCd);
              methods.setValue("unsogaishaNm", data?.meishoNm1);
            }}
            onBlur={() => B000111UnsogaishaNm(methods, navigate, setMsg)}
            {...register(26)}
          />
          <STextField name="unsogaishaNm" gridColumn="span 3" disabled />

          <SLabel gridColumn="1">担当者</SLabel>
          <SNumberField
            name="shainCd"
            code
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("shainCd", data?.shainCd);
              methods.setValue("shainNm", data?.shainNm);
              methods.setValue("bumonCd", data?.bumonCd);
              B000130BumonNm(methods, navigate, setMsg);
            }}
            size={7}
            onBlur={() => HandleChangeShainCd()}
            {...register(27)}
          />
          <STextField name="shainNm" disabled gridColumn="span 4" />
          <SLabel gridColumn={8}>担当部門</SLabel>
          <STextField name="bumonNm" gridColumn="span 4" disabled />

          <SLabel gridColumn={1}>売掛担当者</SLabel>
          <SNumberField
            name="urikakeshainCd"
            label="売掛担当者"
            code
            size={7}
            dialog={<B000140 />}
            handleSubmit={(data: any) => {
              methods.setValue("urikakeshainCd", data?.shainCd);
              methods.setValue("urikakeshainNm", data?.shainNm);
              methods.setValue("urikakebumonCd", data?.bumonCd);
              B000130UrikakebumonNm(methods, navigate, setMsg);
            }}
            onBlur={() => HandleChangeUrikakeshainCd()}
            {...register(28)}
          />
          <STextField name="urikakeshainNm" gridColumn="span 4" disabled />
          <SLabel gridColumn={8}>売掛担当部門</SLabel>
          <STextField name="urikakebumonNm" gridColumn="span 4" disabled />

          <SLabel required gridColumn={1}>
            取引開始年月日
          </SLabel>
          <SDateField
            name="torihikikaishiYmd"
            label="取引開始年月日"
            required
            gridColumn="span 2"
            {...register(29)}
          />
          <SLabel gridColumn={8} required>
            取引終了年月日
          </SLabel>
          <SDateField
            name="torihikishuryoYmd"
            label="取引終了年月日"
            required
            gridColumn="span 3"
            {...register(30)}
          />
        </SFrame>

        <SFrame gridTemplateColumns="8rem 4rem 2rem 2rem 4rem 8rem 5rem 3rem 4rem 1rem 8rem 3rem 4rem 5rem">
          <SLabel gridColumn={1}>締日</SLabel>
          <SNumberField name="shimeD" label="締日" size={2} {...register(31)} />
          <SText align="left">日 </SText>
          <SText gridColumn="span 2" align="center">
            ⇨　
          </SText>
          <SLabel>回収月日</SLabel>
          <SCodeSelect
            name="kaishuyoteiM"
            options={KaishuyoteiM}
            gridColumn="span 2"
            {...register(32)}
          />
          <SNumberField name="kaishuyoteiD" size={2} {...register(33)} />
          <SText align="left">日 </SText>
          <SLabel>回収条件</SLabel>
          <SCodeSelect
            name="kaishuKbn"
            options={KaishuKbn}
            gridColumn="span 2"
            {...register(34)}
          />

          <SLabel gridColumn="1">請求発行</SLabel>
          <SCodeSelect
            name="seikyushoKbn"
            options={SeikyushoKbn}
            gridColumn="span 3"
            {...register(35)}
          />
          <SLabel gridColumn={6}>請求書形式</SLabel>
          <SCodeSelect
            name="seikyushokeishikiKbn"
            options={SeikyushokeishikiKbn}
            gridColumn="span 2"
            {...register(36)}
          />

          <SLabel gridColumn="1">請求書番号採番</SLabel>
          <SCodeSelect
            name="seikyushosaibanKbn"
            options={SeikyushosaibanKbn}
            gridColumn="span 3 "
            {...register(37)}
          />
          <SLabel gridColumn={6}>請求番号</SLabel>
          <SNumberField
            name="seikyushoNo"
            size={10}
            gridColumn="span 2"
            {...register(38)}
          />

          <SLabel gridColumn="1">伝票種別</SLabel>
          <SNumberField
            name="denpyoshubetsuCd"
            code
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.denpyoshubetsu} />}
            handleSubmit={(data: any) => {
              methods.setValue("denpyoshubetsuCd", data?.meishoCd);
              methods.setValue("denpyoshubetsuNm", data?.meishoNm1);
            }}
            onBlur={() => B000111DenpyoshubetsuNm(methods, navigate, setMsg)}
            {...register(40)}
          />
          <STextField
            name="denpyoshubetsuNm"
            label="伝票種別名"
            disabled
            gridColumn="span 3"
          />
          <SLabel gridColumn={11}>伝票行数</SLabel>
          <SNumberField name="denpyogyosu" size={2} {...register(39)} />

          <SLabel gridColumn={1}>伝票区分</SLabel>
          <SNumberField name="denpyoKbn" size={2} {...register(41)} />
          <SLabel gridColumn={6}>添付伝票</SLabel>
          <SNumberField
            name="tenpudenpyoCd"
            size={3}
            dialog={
              <B000111
                meishoKbn={meishoKbn.tenpudenpyo}
                denpyoshubetsuCd={methods.watch("denpyoshubetsuCd")}
              />
            }
            handleSubmit={(data: any) => {
              methods.setValue("tenpudenpyoCd", data?.meishoCd);
              methods.setValue("tenpudenpyoNm", data?.meishoNm1);
            }}
            onBlur={() => B000111TenpudenpyoNm(methods, navigate, setMsg)}
            {...register(42)}
          />
          <STextField name="tenpudenpyoNm" disabled gridColumn="span 3" />
        </SFrame>

        <SFrame gridTemplateColumns="8rem 4rem 4rem 2rem 2rem 8rem 5rem 3rem 1rem 2rem 2rem 8rem 7rem 5rem">
          <SLabel gridColumn="1">率</SLabel>
          <SNumberField name="ritsu" label="率" size={3} {...register(43)} />
          <SLabel gridColumn={6}>分類コード</SLabel>
          <SNumberField name="bunrui" size={3} {...register(44)} />
          <SLabel gridColumn={12}>出力商品コード</SLabel>
          <SCodeSelect
            name="shutsuryokushohinCd"
            options={ShutsuryokushohinCd}
            {...register(45)}
          />

          <SLabel gridColumn="1">取引先コード</SLabel>
          <SNumberField
            name="torihikisakiCd"
            size={12}
            gridColumn="span 3"
            {...register(46)}
          />
          <SText gridColumn="5"></SText>
          <SLabel>百貨店コード</SLabel>
          <SNumberField
            name="hyakatenCd"
            gridColumn="span 4"
            size={12}
            {...register(47)}
          />
          <SLabel gridColumn={12}>社店コード</SLabel>
          <SNumberField
            name="shatenCd"
            size={12}
            gridColumn="span 2"
            {...register(48)}
          />

          <SLabel required gridColumn="1">
            金額丸め
          </SLabel>
          <SCodeSelect
            name="kinmarumeKbn"
            options={KinmaremeKbn}
            required
            gridColumn="span 2"
            {...register(49)}
          />

          <SLabel required gridColumn="1">
            消費税丸め
          </SLabel>
          <SCodeSelect
            name="zeimarumeKbn"
            options={ZeimarumeKbn}
            required
            gridColumn="span 2"
            {...register(50)}
          />
          <SLabel required gridColumn={12}>
            消費税区分
          </SLabel>
          <SCodeSelect
            name="zeiKbn"
            options={ZeiKbn}
            required
            gridColumn="span 2"
            {...register(51)}
          />

          <SLabel required gridColumn="1">
            単価丸め
          </SLabel>
          <SCodeSelect
            name="tankamarumeKbn"
            options={TankamarumeKbn}
            required
            gridColumn="span 2"
            {...register(52)}
          />
          <SLabel required gridColumn={6}>
            単価端数位置
          </SLabel>
          <SCodeSelect
            name="tankahasuichiKbn"
            options={B100060Tankahasuichi}
            required
            gridColumn="span 2"
            {...register(53)}
          />
          <SText>第</SText>
          <SNumberField name="tankahasuichi" size={1} {...register(54)} />
          <SText align="left">位</SText>

          <SLabel required gridColumn="1">
            単価掛率
          </SLabel>
          <SNumberField
            name="tankaKakeritsu"
            required
            size={5}
            {...register(55)}
          />
          <SLabel required gridColumn={6}>
            上代表示区分
          </SLabel>
          <SCodeSelect
            name="jodaihyojiKbn"
            options={JodaihyojiKbn}
            required
            {...register(56)}
          />
          <SLabel gridColumn="1">削除予定区分</SLabel>
          <SCodeSelect
            name="sakujoyoteiKbn"
            options={SakujoyoteiKbn}
            gridColumn="span 2"
            {...register(57)}
          />
          <SLabel gridColumn="1">専用伝票No.区分</SLabel>
          <SCodeSelect
            name="kyakusakinoKbn"
            options={KyakusakinoKbn}
            gridColumn="span 2"
            {...register(58)}
          />
        </SFrame>

        <SFrame gridTemplateColumns="8rem 5rem 3rem 10rem">
          <SLabel gridColumn="span 3">EDI用項目</SLabel>
          <SLabel gridColumn="1">企業コード</SLabel>
          <SNumberField
            name="kigyoCd"
            size={12}
            gridColumn="span 2"
            {...register(59)}
          />
          <SLabel gridColumn="1">店舗コード</SLabel>
          <SNumberField
            name="tenpoCd"
            size={12}
            gridColumn="span 2"
            {...register(60)}
          />
          <Box gridColumn="span 11" />

          <SLabel gridColumn="span 4">得意先分類</SLabel>
          <SLabel gridColumn="1">得意先分類1</SLabel>
          <SNumberField
            name="tokuibunCd1"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.tokuibun1} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuibunCd1", data?.meishoCd);
              methods.setValue("tokuibunNm1", data?.meishoNm1);
            }}
            onBlur={() => B000111TokuibunNm1(methods, navigate, setMsg)}
            {...register(61)}
          />
          <STextField name="tokuibunNm1" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">得意先分類2</SLabel>
          <SNumberField
            name="tokuibunCd2"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.tokuibun2} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuibunCd2", data?.meishoCd);
              methods.setValue("tokuibunNm2", data?.meishoNm1);
            }}
            onBlur={() => B000111TokuibunNm2(methods, navigate, setMsg)}
            {...register(62)}
          />
          <STextField name="tokuibunNm2" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">得意先分類3</SLabel>
          <SNumberField
            name="tokuibunCd3"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.tokuibun3} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuibunCd3", data?.meishoCd);
              methods.setValue("tokuibunNm3", data?.meishoNm1);
            }}
            onBlur={() => B000111TokuibunNm3(methods, navigate, setMsg)}
            {...register(63)}
          />
          <STextField name="tokuibunNm3" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">得意先分類4</SLabel>
          <SNumberField
            name="tokuibunCd4"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.tokuibun4} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuibunCd4", data?.meishoCd);
              methods.setValue("tokuibunNm4", data?.meishoNm1);
            }}
            onBlur={() => B000111TokuibunNm4(methods, navigate, setMsg)}
            {...register(64)}
          />
          <STextField name="tokuibunNm4" disabled gridColumn="span 2" />

          <SLabel gridColumn="1">得意先分類5</SLabel>
          <SNumberField
            name="tokuibunCd5"
            size={3}
            dialog={<B000111 meishoKbn={meishoKbn.tokuibun5} />}
            handleSubmit={(data: any) => {
              methods.setValue("tokuibunCd5", data?.meishoCd);
              methods.setValue("tokuibunNm5", data?.meishoNm1);
            }}
            onBlur={() => B000111TokuibunNm5(methods, navigate, setMsg)}
            {...register(65)}
          />
          <STextField name="tokuibunNm5" disabled gridColumn="span 2" />
        </SFrame>

        <SFrame>
          <SNormalButton
            label={labels.buttons.update}
            align="right"
            {...register(66)}
            dialog={
              <SConfirmDialog
                title="マスタ更新"
                msg="更新します。よろしいですか？"
              />
            }
            dialogAction="confirm"
            handleSubmit={handleClickUpdateButton}
          />
        </SFrame>
      </FormProvider>
    </>
  );
};
